import React from "react";
import PageTitle from "../../components/PageTitle/PageTitle";
import Table from '../../widgets/tables/Table';
import translateString from "../../utils/Locales";
import { NineCellLoading } from 'react-loadingg';
import LoadingOverlay from 'react-loading-overlay';
import getValutazioniTest from "../../services/getValutazioniTest";
import Cookies from "universal-cookie";

let t = translateString;
const qs = require('querystring');


export default class ResultTest extends React.Component {

	constructor(props){
		super (props)
	
		this.state = {
            isLoading: true,
		};
        this.tests = []
    }

    componentDidMount() {
        this.loadTests()
    }

	async loadTests(){
        const cookies = new Cookies();
        const username = cookies.get('username', { path: '/' });
		const token = cookies.get('token', { path: '/' });
		const currentCourse = cookies.get('currentCourse', { path: '/' });
        this.dbPath = cookies.get('db_path', { path: '/' });
        const parsed = qs.parse(window.location.hash);
        let id = parsed['#/app/risultatiEsame?id']
        if (!id) {
            window.location.href = '/' + this.dbPath + "/#/app/dashboard";
            return
        }
        this.tests = await getValutazioniTest(username, token, id, currentCourse);

        this.setState({isLoading: false})
    }

    render() {

        var headCellsTests = [
			{ id: 'nome', numeric: false, disablePadding: false, label: t('nome') },
			{ id: 'cognome', numeric: false, disablePadding: false, label: t('cognome') },
			{ id: 'risultato', numeric: true, disablePadding: false, label: t('risultato') },
		];
        
        this.searchColsTest = ['nome', 'cognome'];

		if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />

        return(
            <LoadingOverlay
			active={this.state.isLoading}
			styles={{
				content: () => ({
					position: 'relative',
					width: '100%',
					top: '200px'
				})
			}}
			spinner
			text={'Loading your content...'}
			>
                <PageTitle title={t('risultati_esame')} />
					<Table headCells={headCellsTests} searchCols={this.searchColsTest}  rows={this.tests} 

					/>
            </LoadingOverlay>
        )
    } 
    
}